import {pickupTimeHistory} from '@/utils/pickupHistory'

/**
 * A ride's pickup time WITH ITS HISTORY — every earlier time struck through, then the
 * current one, on one line, as the screen normally shows it.
 *
 * `format` is the screen's own formatter for a raw `scheduled_at`, so each place keeps its
 * look (time only, date and time, …). An earlier time that formats to the same text as the
 * current one (a date-only row, say) is not repeated.
 *
 * With no history this renders exactly `format(trip.scheduled_at)` and nothing else, so
 * dropping it in where a plain time used to be changes nothing for a ride that never moved.
 */
export default function PickupTime({trip, format, className = '', previousClassName = '', inline = false}) {
    const history = pickupTimeHistory(trip)
    if (!history.length) return null

    const current = format(history[history.length - 1])
    const previous = history.slice(0, -1).map(format).filter((text, i, all) => text && text !== current && all.indexOf(text) === i)

    if (!previous.length) return <span className={className}>{current}</span>

    return (
        /* ONE LINE, side by side and vertically centred — earlier times first, struck
           through, then the current one. (`inline` is still accepted; every placement is
           one line now.) */
        <span className={`inline-flex flex-wrap items-center gap-x-2 ${className}`}>
            {previous.map((text) => (
                <s key={text} className={`opacity-60 ${previousClassName}`} title="Earlier pickup time">{text}</s>
            ))}
            <span>{current}</span>
        </span>
    )
}

export {PickupTime}
